import React from "react";
import { useGameFormData } from "./useGameFormData";
import { useGameForm } from "./useGameForm";
import AvatarHeader from "../components/common/avatar-header/avatar-header";

type UseDisplayFormConfig = {
  customSubmit: () => void;
  titles: string[];
  submitText?: string;
  validation?: { isReady: boolean };
  subHeaders?: string[];
  readyFlash?: boolean;
  countdownThreshold?: number;
  onBack?: () => void;
};

export const useDisplayForm = (config: UseDisplayFormConfig) => {
  const formData = useGameFormData();
  const { handleSubmit, avatarHeaderProps } = useGameForm({
    customSubmit: config.customSubmit,
    playerState: formData.playerState,
  });

  const formPageProps = {
    header: React.createElement(AvatarHeader, {
      titles: config.titles,
      ...avatarHeaderProps,
    }),
    ...formData,
    ready: config.validation?.isReady ?? true,
    submitText: config.submitText,
    onSubmit: handleSubmit,
    subHeaders: config.subHeaders,
    readyFlash: config.readyFlash,
    countdownThreshold: config.countdownThreshold,
    onBack: config.onBack,
  };

  return { formPageProps };
};
